var map = {
	"./event.js": "1ltv",
	"./pageDesign.js": "qrJQ",
	"./setting.js": "ZDz2",
	"./user.js": "bpXy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Xrqz";


//////////////////
// WEBPACK FOOTER
// ./src/SRM/store/modules nonrecursive \.js$
// module id = Xrqz
// module chunks = 95